'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import { RiArrowLeftLine } from 'react-icons/ri';
import ThemedButton from '@/components/common/buttons/Button';

const GoBackButton: React.FC = () => {
  const router = useRouter();

  const goBack = () => {
    if (window.history.length > 1) router.back();
    else router.push('/');
  };

  return (
    <ThemedButton
      variant="outline"
      text="Go back"
      icon={<RiArrowLeftLine />}
      onClick={goBack}
    />
  );
};

export default GoBackButton;
